import React, { useState, useEffect } from "react";
import PageContainer from "../pages/PageContainer";
import Loader from "../Loader";
import { useOutletContext, useParams } from "react-router-dom";
import { cancelOrderApi, getOrder } from "../../api/user";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import {
  faEdit,
  faEllipsisV,
  faTrash,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteOrderModal from "../Modals/deleteOrderModal";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "d3-format";
import GameSideBar from "./GameSideBar";

function formatNumber(num) {
  // Convert input to a number in case it's provided as a string
  num = parseFloat(num);

  // Determine if the number is an integer
  if (Number.isInteger(num)) {
    return new Intl.NumberFormat("en-US").format(num); // Format as a US number without decimals
  } else {
    // Check the number of decimal places
    const decimalPlaces = (num.toString().split(".")[1] || []).length;

    if (decimalPlaces === 1) {
      // If there is one decimal place, format to two decimal places
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    } else {
      // If there are two decimal places, format it with those decimals
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(num);
    }
  }
}

const PortfolioSection = (props) => {
  const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const user_id = props.user_id ?? null;
  const isSelfProfile = props.isSelfProfile ?? true;
  const ignoreDesign = props.ignoreDesign ?? false;

  const navigate = useNavigate();
  const isMobileView = document.body.clientWidth <= 768;
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);
  const [holdings, setHoldings] = useState([]);
  const [activeButtons, setActiveButtons] = useState("holdings");
  const [ids, setIds] = useState(0);
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [sidebarToggle] = useOutletContext();
  const [dropdownStates, setDropdownStates] = useState(
    openTrades.map(() => false)
  );
  const [freeCoin, setFreeCoin] = useState("");
  const [PortfolioCoin, setPortfolioCoin] = useState("");
  const location = useLocation();
  const { traderProfile } = location.state || {};
  const { userId } = useParams();
  const isIdPresent = !!userId; // This will be true if id is present, false otherwise
  const toggleOffAllDropdowns = () => {
    setDropdownStates(openTrades.map(() => false));
  };
  useEffect(() => {
    if (activeButtons === "holdings") {
      fetchOrder(3);
    }
  }, []);

  const handleOpenTradesClick = async () => {
    setActiveButtons("openTrades");
    setButtonDropdownState(null);
    toggleOffAllDropdowns();
    await fetchOrder(1);
  };

  const toggleDropdown = (index) => {
    const newDropdownStates = [...dropdownStates];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates(newDropdownStates);
  };

  const handleClosedTradesClick = async () => {
    setActiveButtons("closedTrades");
    toggleOffAllDropdowns();
    setButtonDropdownState(null);
    await fetchOrder(2);
  };

  const handleHoldingsTradesClick = async () => {
    setButtonDropdownState(null);
    setActiveButtons("holdings");
    toggleOffAllDropdowns();
    await fetchOrder(3);
  };
  const fetchOrder = async (type) => {
    try {
      setLoader(true);

      let response;
      if (userId) {
        response = await getOrder(type, userId, game_id); // Send userId to API if available
      } else {
        if(user_id){
          response = await getOrder(type, user_id, game_id);
        }else{
          response = await getOrder(type, null, game_id); // Otherwise, call the API without userId
        }
      }

      if (response?.data?.status === 200) {
        if (
          response?.data?.data?.data.length > 0 ||
          response?.data?.data?.data.length === 0
        ) {
          if (type === 1) {
            setHoldings([]);
            setOpenTrades(response?.data?.data?.data);
          } else if (type === 2) {
            setClosedTrades(response?.data?.data?.data);
          } else if (type === 3) {
            setHoldings(response?.data?.data?.data);

            if(game_id){
              setFreeCoin(
                response?.data?.data?.coin ||
                response?.data?.data?.data[0].game_free_coin
              );
            }else{
              setFreeCoin(
                response?.data?.data?.coin ||
                response?.data?.data?.data[0].free_coin
              );
            }

            if(game_id){
              setPortfolioCoin(
                response?.data?.data?.portfolio_coin ||
                  response?.data?.data?.data[0].game_portfolio_coin
              );
            }else{
              setPortfolioCoin(
                response?.data?.data?.portfolio_coin ||
                  response?.data?.data?.data[0].portfolio_coin
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader(false);
    }
  };

  const formatCreatedAt = (createdAt) => {
    const currentTimeUTC = createdAt ? createdAt : moment.utc().format();
    const localTimeZone = moment.tz.guess();
    const localTime = moment
      .utc(currentTimeUTC)
      .tz(localTimeZone)
      .format("MMMM DD, YYYY hh:mm A");
    return localTime;
  };
  const formatCreatedAtHolding = (createdAt) => {
    const currentTimeUTC = createdAt ? createdAt : moment.utc().format();
    const localTimeZone = moment.tz.guess();
    const localTime = moment
      .utc(currentTimeUTC)
      .tz(localTimeZone)
      .format("MMMM DD, YYYY");
    return localTime;
  };
  const handleCancelOrder = async (id) => {
    setIds(id);
    setOpenModal(true);
  };

  const handleEditClick = async (trade) => {

    console.log("trade >>> ",trade)
    setButtonDropdownState(null);
    localStorage.setItem("trade", JSON.stringify(trade));

    if (activeButtons === "holdings") {
      localStorage.setItem("holding", "true");

      if(game_id){
        navigate(`/${slug}/buysell?from=holdings`);
      }else{
        navigate(`/buysell?from=holdings`);
      }

    } else {

      if(game_id){
        navigate(`/${slug}/buysell/${trade?.id}`);
      }else{
        navigate(`/buysell/${trade?.id}`);
      }
    }
  };

  const handleDeleteOrder = async () => {
    const res = await cancelOrderApi(ids);
    if (res?.data?.status === 200) {
      setOpenModal(false);
      if (activeButtons === "openTrades") {
        fetchOrder(1);
      } else {
        fetchOrder(2);
      }
      toast.success(res?.data?.message);
    } else {
      toast.error(res?.data?.message);
    }
  };

  const handleDeleteCancel = () => {
    setOpenModal(false);
  };

  const formattedCurrency = format("$,.2f")(1234567.89);
  const customFormattedCurrency = format("$,.4s")(1234567.89);
  const [buttonDropdownState, setButtonDropdownState] = useState(null);

  const toggleButtonDropdown = (currentIndex) => {
    if (buttonDropdownState === currentIndex) {
      setButtonDropdownState(null);
    } else {
      setButtonDropdownState(currentIndex);
    }
  };

  return (
    <>
      <PageContainer gamePage={game_id && true && !ignoreDesign}>
        { slug && <GameSideBar slug={slug} activeMenu={ user_id ? "" : "portfolio"} />}
        <div>
          {loader ? (
            <Loader />
          ) : (
            <div className="bg-white">
              <main
                className={
                  isMobileView
                    ? "h-full bg-white justify-center"
                    : "h-full bg-white justify-center"
                }
              >
                <div
                  className={
                    isMobileView
                      ? `pt-4 py-3 px-3 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto ${"mb-24"} `
                      : activeButtons === "holdings"
                      ? `pt-8 pb-2 px-8 rounded-xl border bg-white border-white-500 max-w-4xl w-full mx-auto mb-12`
                      : "p-8 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto mb-12"
                  }
                >
                  <div className="flex justify-center space-x-4 mb-4">
                    <button
                      onClick={handleOpenTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "openTrades"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F] border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Open Orders
                    </button>
                    <button
                      onClick={handleHoldingsTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "holdings"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F]  border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Current Holdings{" "}
                    </button>
                    <button
                      onClick={handleClosedTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "closedTrades"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F] border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Closed Trades
                    </button>
                  </div>

                  {activeButtons === "openTrades" ? (
                    <>
                      {!loader && openTrades.length > 0
                        ? openTrades.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center "
                            >
                              <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` }>
                                <div
                                  className={` max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    !trade?.id
                                      ? "bg-primaryColor"
                                      : trade?.order_type === 3 &&
                                        activeButtons === "openTrades" &&
                                        !trade?.id
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {trade?.stock_symbol}
                                  </span>
                                </div>
                              </Link>

                              <div className="pl-3 flex flex-col">
                                {trade?.order_type === 3 ? (
                                  <p className="text-[12px] text-[#888888] font-inter md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 3
                                      ? "SHORT SELL"
                                      : ""}
                                  </p>
                                ) : (
                                  <p className="text-[12px] text-[#888888] font-inter  md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 1
                                      ? "BUY"
                                      : trade?.order_type === 5
                                      ? "BUY"
                                      : trade?.order_type === 4
                                      ? "Holdings"
                                      : "SELL"}
                                  </p>
                                )}

                                <p className="md:text-[10.5px] text-[10.5px] leading-relaxed text-[#888888] font-inter">
                                  {formatCreatedAt(trade?.updated_at)}
                                </p>

                                <p className="text-xs leading-3 text-gray-500">
                                  {trade?.action}
                                </p>
                              </div>
                              <div
                                className={
                                  isMobileView
                                    ? "flex flex-col justify-end ml-auto space-y-1"
                                    : "flex flex-col justify-end ml-auto space-y-2"
                                }
                              >
                                <div>
                                  <p
                                    className={`text-end md:text-[11px] text-[11px] font-semibold font-poppins ${
                                      trade?.order_type === 2
                                        ? "text-[#FF4B4B]"
                                        : "text-[#009D00]"
                                    }`}
                                  >
                                    $
                                    {new Intl.NumberFormat("en-US").format(
                                      trade.pnl_amount
                                    )}
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                    {/* {trade.pnl_amount % 1 !== 0
                                        ? Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }
                                          )
                                        : Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )} */}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] font-semibold  whitespace-nowrap">
                                    <span style={{ color: "#888888" }}>At</span>{" "}
                                    <span style={{ color: "#888888" }}>
                                      {" "}
                                      $
                                      {trade.order_price.toLocaleString(
                                        "en-US",
                                        {
                                          // style: "currency",
                                          // currency: "USD",
                                        }
                                      )}
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] text-[#888888] mb-[6px] md:mb-[] ">
                                    (
                                    {(trade?.order_quantity).toLocaleString(
                                      "en-US"
                                    )}
                                    )
                                  </p>
                                </div>
                              </div>
                              { (activeButtons === "openTrades" &&
                              !userId &&
                              trade?.id !== null && isSelfProfile === true ) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >

                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : activeButtons === "closedTrades" ? (
                    <>
                      {!loader && closedTrades.length > 0
                        ? closedTrades.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center"
                            >
                              <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` }>
                                <div
                                  className={`max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    trade?.order_type === 3 &&
                                    activeButtons === "openTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {trade?.stock_symbol}
                                  </span>
                                </div>
                              </Link>

                              <div className="pl-3 flex flex-col">
                                {trade?.order_type === 3 ? (
                                  <p className="md:text-[12px] text-[12px] text-[#888888] font-inter md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 3
                                      ? "SHORT SELL"
                                      : ""}
                                  </p>
                                ) : (
                                  <p className="md:text-[12px] text-[12px] text-[#888888] font-inter md:mb-[2.2rem]  mb-[1.7rem]">
                                    {trade?.order_type === 1
                                      ? "BUY"
                                      : trade?.order_type === 2 ||
                                        trade?.order_type === 3
                                      ? "SELL"
                                      : trade?.order_type === 4
                                      ? "HOLDING"
                                      : trade?.order_type === 5
                                      ? "BUY"
                                      : "SELL"}
                                  </p>
                                )}

                                <p className="md:text-[10.5px] text-[10.5px] leading-relaxed text-[#888888] font-inter">
                                  {formatCreatedAt(trade?.updated_at)}
                                </p>

                                <p className="text-xs leading-3 text-gray-500">
                                  {trade?.action}
                                </p>
                              </div>
                              <div
                                className={
                                  isMobileView
                                    ? "flex flex-col justify-end ml-auto space-y-1"
                                    : "flex flex-col justify-end ml-auto space-y-2"
                                }
                              >
                                <div>
                                  <p
                                    className={`text-end md:text-[11px] text-[11px] font-semibold font-poppins ${
                                      trade?.order_type === 2
                                        ? "text-[#FF4B4B]"
                                        : "text-[#009D00]"
                                    }`}
                                  >
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                    ${formatNumber(trade.pnl_amount)}
                                    {/* {Number(trade.pnl_amount).toLocaleString(
                                        "en-US",
                                        {
                                          style: "currency",
                                          currency: "USD",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )} */}
                                    {/* {trade.pnl_amount % 1 !== 0
                                        ? Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }
                                          )
                                        : Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )} */}
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] font-semibold  whitespace-nowraps">
                                    <span style={{ color: "#888888" }}>At</span>{" "}
                                    <span style={{ color: "#888888" }}>
                                      ${formatNumber(trade?.order_price)}
                                      {/* {trade?.order_price.toLocaleString("en-US")} */}
                                      {/* {"$"}
                                        {Number(trade?.order_price).toFixed(2)} */}
                                      {/* {Number(trade.order_price).toLocaleString(
                                          "en-US",
                                          {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )} */}
                                      {/* {trade.order_price % 1 !== 0
                                          ? Number(
                                              trade.order_price
                                            ).toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })
                                          : Number(
                                              trade.order_price
                                            ).toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            })} */}
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] text-[#888888] mb-[6px]">
                                    ({formatNumber(trade?.order_quantity)}
                                    {/* {(trade?.order_quantity).toLocaleString(
                                        "en-US"
                                      )} */}
                                    )
                                  </p>
                                </div>
                              </div>
                              { ( activeButtons === "openTrades" &&
                              trade?.id !== null && isSelfProfile  === true) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : activeButtons === "holdings" ? (
                    <>
                      {!loader && holdings.length > 0
                        ? holdings.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center"
                            >
                              <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` } >
                                <div
                                  className={`max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    trade?.order_type === 3 &&
                                    activeButtons === "openTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {trade?.stock_symbol}
                                  </span>
                                </div>
                              </Link>

                              <div
                                className="flex flex-col w-full ml-2"
                                style={{ gap: "4px" }}
                              >
                                <div className="grid grid-cols-2 justify-between">
                                  <div className="flex flex-col">
                                    <p className="text-[12px] text-[#888888] font-inter">
                                      {trade?.order_type === 3
                                        ? "SHORT SELL"
                                        : trade?.order_type === 1
                                        ? "BUY"
                                        : trade?.order_type === 4
                                        ? "LONG POSITION"
                                        : trade?.order_type === 5
                                        ? "BUY"
                                        : "SELL"}
                                    </p>
                                  </div>
                                  <div className="text-right">
                                    {/* <p
                                      style={{
                                        color:
                                          trade?.order_type === 3
                                            ? trade?.pnl_amount <
                                              trade?.executed_amount
                                              ? "#009D00"
                                              : "#FF4B4B"
                                            : trade?.order_type === 4
                                            ? trade?.pnl_amount <
                                              trade?.executed_amount
                                              ? "#FF4B4B"
                                              : "#009D00"
                                            : "",
                                      }}
                                      className="text-[11px] font-semibold"
                                    > */}
                                    <p
                                      style={{
                                        color:
                                          trade?.order_type === 3
                                            ? parseFloat(trade?.pnl_amount) < parseFloat(trade?.executed_amount)
                                              ? "#009D00"
                                              : "#FF4B4B"
                                            : trade?.order_type === 4
                                            ? parseFloat(trade?.pnl_amount) < parseFloat(trade?.executed_amount)
                                              ? "#FF4B4B"
                                              : "#009D00"
                                            : "",
                                      }}
                                      className="text-[11px] font-semibold"
                                    >
                                      $
                                      {`${Math.abs(
                                        trade?.pnl_amount -
                                          trade?.executed_amount
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits:
                                          Math.abs(
                                            trade?.pnl_amount -
                                              trade?.executed_amount
                                          ) %
                                            1 !==
                                          0
                                            ? 2
                                            : 0,
                                        maximumFractionDigits:
                                          Math.abs(
                                            trade?.pnl_amount -
                                              trade?.executed_amount
                                          ) %
                                            1 !==
                                          0
                                            ? 2
                                            : 0,
                                      })}`}
                                    </p>
                                  </div>
                                </div>
                                <div className="grid grid-cols-1 justify-between">
                                  <div className="flex md:flex-row flex-col justify-end text-right text-[11px] font-semibold text-[#888888]">
                                    <div className="flex md:flex-row flex-col justify-end text-right text-[11px] font-semibold text-[#888888]">
                                      At {"$"}
                                      {trade.excuted_rate % 1 !== 0
                                        ? new Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(trade.excuted_rate)
                                        : new Intl.NumberFormat("en-US").format(
                                            trade.excuted_rate
                                          )}{" "}
                                      (${formatNumber(trade?.executed_amount)})
                                    </div>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 justify-between items-start mb-1">
                                  <div className="text-xs text-[#888888]">
                                    {activeButtons === "holdings"
                                      ? formatCreatedAtHolding(
                                          trade?.updated_at
                                        )
                                      : formatCreatedAt(trade?.created_at)}
                                  </div>
                                  <div className="text-right text-[11px] text-[#888888]">
                                    <span>
                                      ({formatNumber(trade?.order_quantity)}
                                      {/* {(trade?.order_quantity).toLocaleString(
                                          "en-US"
                                        )} */}
                                      )
                                    </span>
                                  </div>
                                </div>
                              </div>
                              { ( activeButtons === "openTrades" &&
                              trade?.id !== null && isSelfProfile === true ) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 left-0 z-10 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                              {activeButtons === "holdings" && !isIdPresent && isSelfProfile === true ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleButtonDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {buttonDropdownState === index && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                        onClick={() => handleEditClick(trade)}
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faWallet} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : (
                    ""
                  )}
                  {activeButtons === "holdings" && freeCoin  ? (
                    <div className={"flex flex-col justify-center"}>
                      <p
                        className={
                          "font-bold text-center text-primaryColor mt-4"
                        }
                      >
                        Free Cash:{" "}
                        {Number(freeCoin).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                      <span className="font-bold text-center text-primaryColor mt-2">
                        {/* {console.log(PortfolioCoin, "jsx")}
                          Portfolio: {format("$,.2f")(PortfolioCoin)} */}
                        Portfolio:{" "}
                        {Number(PortfolioCoin).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </main>
            </div>
          )}
        </div>
        <DeleteOrderModal
          isOpen={openModal}
          handleDeleteCard={handleDeleteOrder}
          handleDeleteCancel={handleDeleteCancel}
        >
          <p className="mb-4 -mt-4">
            Are you sure you want to Cancel this order?
          </p>
        </DeleteOrderModal>
      </PageContainer>
    </>
  );
};

export default PortfolioSection;
